/**
 * Google Analytics 4 helpers.
 * Measurement ID is configured in /public/index.html (gtag bootstrap).
 *
 * Usage:
 *   import { trackEvent, trackPageView } from "../lib/analytics";
 *   trackEvent("donation_started", { amount: 50, currency: "usd" });
 */

const isBrowser = typeof window !== "undefined";

/** Send a page_view (called by RouteChangeTracker on every SPA navigation). */
export function trackPageView(pathname, title) {
    if (!isBrowser || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
        page_title: title || document.title,
    });
}

/** Send a custom event. Safe to call before gtag.js loads (silently no-ops). */
export function trackEvent(eventName, params = {}) {
    if (!isBrowser || typeof window.gtag !== "function") return;
    try {
        window.gtag("event", eventName, params);
    } catch (e) {
        // Swallow — never break the UI on analytics failure
    }
}

/** Tag the current user (id, role, org) on login so events are attributable. */
export function setUserContext({ user_id, role, org_id, org_name } = {}) {
    if (!isBrowser || typeof window.gtag !== "function") return;
    const props = {};
    if (user_id) props.user_id = user_id;
    if (role) props.user_role = role;
    if (org_id) props.org_id = org_id;
    if (org_name) props.org_name = org_name;
    try {
        if (user_id) window.gtag("config", "G-CFV2XQ2T68", { user_id });
        if (Object.keys(props).length) window.gtag("set", "user_properties", props);
    } catch (e) { /* ignore */ }
}
